export { default as MyPortfoliosTable } from './component';
